import ModalSeguimientoLead from 'akasia-components/leads/ModalSeguimientoLead';
import classNames from 'classnames';
import { useToast } from 'context/providers/ToastProvider';
import createMarkup from 'helpers/createMarkup';
import useToken from 'hooks/useToken';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { Card, Col, Row, } from 'react-bootstrap';
import InfiniteScroll from "react-infinite-scroll-component";
import Skeleton from 'react-loading-skeleton';
import { useNavigate } from 'react-router-dom';
import greetingImage from '../../assets/img/illustrations/logo_esfera_.fw.png';
import greetingsBg from '../../assets/img/illustrations/ticket-greetings-bg.png';
import Background from '../../components/common/Background';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClock, faBan, faExclamationCircle } from '@fortawesome/free-solid-svg-icons';
import ImagenPerfil from '../../components/common/ImagenPerfil';

const NotificationItem = ({
    notification,
    setIdLead,
    setShowModalSeguimientoLead
}) => {
    const { token } = useToken();
    const { showErrorToast } = useToast();
    const navigate = useNavigate();

    let objAction = {};
    try {
        objAction = notification?.vJsonAction ? JSON.parse(notification.vJsonAction) : {};
    } catch {
        objAction = {};
    }

    const cuerpoRaw = notification?.vCuerpo || '';
    const cuerpoLower = cuerpoRaw.toLowerCase();
    const tituloLower = (notification?.vTitulo || '').toLowerCase();
    const actionTipo = (objAction?.tipoCancelacion || '').toUpperCase();

    // Detección de notificación en proceso de cancelación (programada)
    const isCancelacionProgramada =
        actionTipo === 'PROGRAMADA' ||
        tituloLower.includes('cancelación programada') ||
        tituloLower.includes('cancelacion programada') ||
        cuerpoLower.includes('programó la cancelación') ||
        cuerpoLower.includes('programo la cancelacion') ||
        cuerpoLower.includes('cancelación programada') ||
        cuerpoLower.includes('cancelacion programada');

    // Detección de notificación cancelada por completo (definitiva/finalizada)
    const isCancelacionCompleta =
        !isCancelacionProgramada && (
            actionTipo === 'DEFINITIVA' ||
            tituloLower.includes('cancelación de suscripción') ||
            tituloLower.includes('cancelacion de suscripcion') ||
            cuerpoLower.includes('se canceló la suscripción') ||
            cuerpoLower.includes('se cancelo la suscripcion') ||
            cuerpoLower.includes('se canceló por completo') ||
            cuerpoLower.includes('se cancelo por completo') ||
            cuerpoLower.includes('concluyó su período pagado') ||
            cuerpoLower.includes('concluyo su periodo pagado')
        );

    // Ocultar cualquier texto "Motivo: ..." y simplificar texto de cancelación ("del cliente" está de más)
    let cleanCuerpo = cuerpoRaw.replace(/\.?\s*Motivo\s*:\s*[^<.]*(?=<|$|\.)/gi, '');
    if (isCancelacionProgramada || isCancelacionCompleta) {
        cleanCuerpo = cleanCuerpo
            .replace(/\s+por\s+completo/gi, '')
            .replace(/\s+del\s+cliente(?:\s*<[^>]+>[^<]*<\/[^>]+>)?(?:\s*#?\d+)?\s*\.?/gi, '.');
    }

    // Maneja el click para abrir el modal de seguimiento de lead
    const clickToModalSeguimientoLead = (idLead) => {
        setIdLead(idLead);
        setShowModalSeguimientoLead(true);
        notification.bFueMostrado = true;
        marcarNotificacionComoMostrada(notification.idNotificacion);
    };

    const clickToUrl = () => {
        notification.bFueMostrado = true;
        marcarNotificacionComoMostrada(notification.idNotificacion);
        if (objAction?.detalles?.vUrl) {
            navigate(objAction.detalles.vUrl);
        }
    };

    const marcarNotificacionComoMostrada = async (idNotificacion) => {
        var jDataSend = {};
        jDataSend.idNotificacion = idNotificacion;

        const response = await fetch("/api/account/MarcarNotificacionComoMostrada/", {
            method: 'POST',
            headers: {
                'Authorization': 'Bearer ' + token,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(jDataSend)
        }).catch((error) => {
            console.log('Hubo un problema con la peticion Fetch:' + error);
        });

        if (response && response.ok) {
            const data = await response.json();
            if (data.iResponseType != 1) {
                showErrorToast(data.vMessage);
            }
        } else if (response) {
            showErrorToast(response.status + ' ' + response.statusText);
        }
    };

    let itemStyle = { cursor: 'pointer', border: 'none', transition: 'all 0.15s ease' };
    if (isCancelacionProgramada) {
        itemStyle = {
            ...itemStyle,
            borderLeft: '4px solid #f59e0b',
            backgroundColor: notification.bFueMostrado ? '#fffdf7' : '#fffbeb'
        };
    } else if (isCancelacionCompleta) {
        itemStyle = {
            ...itemStyle,
            borderLeft: '4px solid #ef4444',
            backgroundColor: notification.bFueMostrado ? '#fffafa' : '#fef2f2'
        };
    }

    return (
        <div
            style={itemStyle}
            className={classNames(
                (isCancelacionProgramada || isCancelacionCompleta) ? 'px-3 py-2' : 'p-2',
                'shadow-none notification-item d-flex align-items-center rounded-0',
                { 'notification-unread': !notification.bFueMostrado && !isCancelacionProgramada && !isCancelacionCompleta }
            )}
            onClick={() => {
                if (objAction.TypeAction == 1) {
                    if (objAction.detalles?.idModalType == 1) {
                        clickToModalSeguimientoLead(objAction.detalles?.data?.idLead);
                    }
                }
                if (objAction.TypeAction == 2) {
                    clickToUrl();
                }
            }}
        >
            <div className="notification-avatar me-2 justify-items-center">
                {isCancelacionProgramada ? (
                    <div
                        className="d-flex align-items-center justify-content-center rounded-circle shadow-sm"
                        style={{
                            width: '32px',
                            height: '32px',
                            minWidth: '32px',
                            backgroundColor: '#fef3c7',
                            color: '#d97706',
                            border: '1px solid #fde68a'
                        }}
                    >
                        <FontAwesomeIcon icon={faExclamationCircle} style={{ fontSize: '0.95rem' }} />
                    </div>
                ) : isCancelacionCompleta ? (
                    <div
                        className="d-flex align-items-center justify-content-center rounded-circle shadow-sm"
                        style={{
                            width: '32px',
                            height: '32px',
                            minWidth: '32px',
                            backgroundColor: '#fee2e2',
                            color: '#dc2626',
                            border: '1px solid #fecaca'
                        }}
                    >
                        <FontAwesomeIcon icon={faBan} style={{ fontSize: '0.95rem' }} />
                    </div>
                ) : (
                    <ImagenPerfil idUsuario={notification.idUsuarioSource} />
                )}
            </div>

            <div className="notification-body flex-grow-1">
                {isCancelacionProgramada && (
                    <div className="d-flex justify-content-between align-items-center mb-1">
                        <span
                            className="badge"
                            style={{
                                backgroundColor: '#fef3c7',
                                color: '#92400e',
                                border: '1px solid #fde68a',
                                fontSize: '10px',
                                fontWeight: 700,
                                letterSpacing: '0.3px',
                                textTransform: 'uppercase',
                                padding: '2px 7px',
                                borderRadius: '4px'
                            }}
                        >
                            <FontAwesomeIcon icon={faClock} className="me-1" />
                            Cancelación Programada
                        </span>
                        <span
                            style={{
                                width: '7px',
                                height: '7px',
                                borderRadius: '50%',
                                backgroundColor: '#f59e0b',
                                display: 'inline-block'
                            }}
                            title="Cancelación en proceso"
                        />
                    </div>
                )}

                {isCancelacionCompleta && (
                    <div className="d-flex justify-content-between align-items-center mb-1">
                        <span
                            className="badge"
                            style={{
                                backgroundColor: '#fee2e2',
                                color: '#991b1b',
                                border: '1px solid #fecaca',
                                fontSize: '10px',
                                fontWeight: 700,
                                letterSpacing: '0.3px',
                                textTransform: 'uppercase',
                                padding: '2px 7px',
                                borderRadius: '4px'
                            }}
                        >
                            <FontAwesomeIcon icon={faBan} className="me-1" />
                            Suscripción Cancelada
                        </span>
                        <span
                            style={{
                                width: '7px',
                                height: '7px',
                                borderRadius: '50%',
                                backgroundColor: '#ef4444',
                                display: 'inline-block'
                            }}
                            title="Cancelada definitivamente"
                        />
                    </div>
                )}

                <p className="mb-1 text-dark" style={{ fontSize: '0.82rem', lineHeight: '1.25' }} dangerouslySetInnerHTML={createMarkup(cleanCuerpo)} />
                <span className="notification-time text-muted" style={{ fontSize: '0.72rem' }}>
                    {notification.time}
                </span>
            </div>
        </div>
    );
};

const NotificationSection = ({
    setIdLead,
    setShowModalSeguimientoLead
}) => {

    const { token, setToken } = useToken();
    const { showErrorToast } = useToast();

    const [notificaciones, setNotificaciones] = useState([]);
    const [lastNotf, setLastNotf] = useState(0);

    const obtenerNotificacionesPorCategoria = async () => {

        var jDataSend = {};
        jDataSend.idCatNotificacion = -1;
        jDataSend.lastNotification = lastNotf;
        jDataSend.iFirstNotification = 0;

        console.log(jDataSend);

        const response = await fetch("/api/account/obtenerNotificacionesPorCategoria/",
            {
                method: 'POST',
                headers:
                {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(jDataSend)
            }).catch((error) => {

                showErrorToast('Hubo un problema con la peticion Fetch:' + error);
                console.log('Hubo un problema con la peticion Fetch:' + error);
            });

        if (response.ok) {

            console.log("============ OBTENER NOTIFICACIONES ============");
            console.log("response notificaciones: ", response);
            const data = await response.json();
            console.log("data notificaciones: ", data);

            if (data.iResponseType == 1) {

                var detalles = JSON.parse(data.detalles);
                console.log("detalles: ", detalles);

                setNotificaciones(prevNotificaciones => [
                    ...prevNotificaciones,
                    ...detalles.table2
                ]);

                setLastNotf(detalles.table3[0].minimo);

            } else {
                console.log("Error: ", data.vMessage);
            }

        }
        else {
            if (response.status == 401) {
                setToken(null);
                location.href = "";
            }
            console.log(response);
        }
    }

    const fetchMoreData = () => {
        obtenerNotificacionesPorCategoria();
    };

    useEffect(() => {
        obtenerNotificacionesPorCategoria();
    }, []);

    return (
        <>
            <Row className="card shadow-none border-bottom">
                <Col className=" col-12 p-0">
                    <Row id={"targetScrollNtf"} className="card-body p-1 overflow-auto m-0" style={{ height: 660 }} >
                        <Col className="notification-section col-12" >
                            {
                                <>
                                    <InfiniteScroll
                                        dataLength={notificaciones.length}
                                        next={fetchMoreData}
                                        hasMore={lastNotf ? true : false}
                                        loader={<NotificationSkeleton />}
                                        scrollableTarget={"targetScrollNtf"}
                                        scrollThreshold={0.99}
                                    >
                                        {
                                            notificaciones.map(notificacion => (
                                                <NotificationItem
                                                    key={notificacion.idNotificacion}
                                                    notification={notificacion}
                                                    setIdLead={setIdLead}
                                                    setShowModalSeguimientoLead={setShowModalSeguimientoLead}
                                                />
                                            ))
                                        }
                                    </InfiniteScroll>
                                </>

                            }
                        </Col>
                    </Row>
                </Col>
            </Row>
        </>
    );
};

const NotificationsPage = () => {

    const [showModalSeguimientoLead, setShowModalSeguimientoLead] = useState(false);
    const [idLead, setIdLead] = useState(0);

    useEffect(() => {
        //obtenerNotificaciones();
    }, []);

    return (
        <>

            <Row>

                <Col className="col-12 mb-3">

                    <Card className="bg-light shadow-none">
                        <Background image={greetingsBg} className="bg-card d-none d-sm-block" />
                        <Card.Header className="d-flex align-items-center z-index-1 p-0">
                            <img src={greetingImage} alt="" width="96" />
                            <div className="ms-n3">
                                <h6 className="mb-1 text-primary">Bienvenido a </h6>
                                <h4 className="mb-0 text-primary fw-bold">
                                    Notificaciones
                                    <span className="text-info fw-medium"> Akasia </span>
                                </h4>
                            </div>
                        </Card.Header>
                    </Card>

                </Col>

                <Col className="col-12 mb-3">

                    <Row>

                        <Col className="col-12">
                            <Card className="h-100">
                                <Card.Body>

                                    <div className="notifications">
                                        <div className="notification-container">
                                            {

                                                <>
                                                    <NotificationSection
                                                        setShowModalSeguimientoLead={setShowModalSeguimientoLead}
                                                        idTipoNotificacion={1}
                                                        setIdLead={setIdLead}
                                                    />
                                                </>


                                            }
                                        </div>
                                    </div>

                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                </Col>

            </Row>


            <ModalSeguimientoLead
                showModal={showModalSeguimientoLead}
                setShowModal={setShowModalSeguimientoLead}
                idLead={idLead}
                setIdLead={setIdLead}
            />
        </>
    );
};

const NotificationSkeleton = () => {
    return (
        <>
            <Row
                style={{ border: 'none' }}
                className={classNames(
                    'p-1 shadow-none  d-flex align-items-center rounded-0',
                    'notification-skeleton'
                )}
            >
                <Col className="col-1 pe-0">
                    <Skeleton circle width={50} height={50} />
                </Col>
                <Col className="col-11 ps-2">
                    <Skeleton height={40} />
                </Col>
            </Row>

            <Row
                style={{ border: 'none' }}
                className={classNames(
                    'p-1 shadow-none  d-flex align-items-center rounded-0',
                    'notification-skeleton'
                )}
            >
                <Col className="col-1 pe-0">
                    <Skeleton circle width={50} height={50} />
                </Col>
                <Col className="col-11 ps-2">
                    <Skeleton height={40} />
                </Col>
            </Row>

            <Row
                style={{ border: 'none' }}
                className={classNames(
                    'p-1 shadow-none  d-flex align-items-center rounded-0',
                    'notification-skeleton'
                )}
            >
                <Col className="col-1 pe-0">
                    <Skeleton circle width={50} height={50} />
                </Col>
                <Col className="col-11 ps-2">
                    <Skeleton height={40} />
                </Col>
            </Row>
        </>

    );
};

NotificationSection.propTypes = {
    setIdLead: PropTypes.func,
    setShowModalSeguimientoLead: PropTypes.func,
};

NotificationItem.propTypes = {
    notification: PropTypes.object,
    setIdLead: PropTypes.func,
    setShowModalSeguimientoLead: PropTypes.func,
};

export default NotificationsPage;
